import { useCallback, useState } from "react";

export const useModal = (): [boolean, () => void] => {
    const [open, setOpen] = useState(false);

    const toggleOpen = useCallback(() => {
        setOpen((_open) => !_open);
    }, [setOpen]);

    return [open, toggleOpen];
};
